export default "__VITE_ASSET__C45RQ2i5__"